import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { createApiCallEffects } from '../../../common/store/generic.effects';
import { ClaimTypeAction, claimTypeActions } from './claim-type.actions';
import { ClaimTypeApiService } from './claim-type.api.service';

@Injectable()
export class ClaimTypeEffects {
  constructor(
    private readonly claimTypeApiService: ClaimTypeApiService,
    private readonly action$: Actions<ClaimTypeAction>,
  ) {}

  getById = createApiCallEffects(
    this,
    this.action$,
    claimTypeActions.getById,
    this.claimTypeApiService.getById,
  );

  createInstance = createApiCallEffects(
    this,
    this.action$,
    claimTypeActions.createInstance,
    this.claimTypeApiService.createInstance,
  );

  add = createApiCallEffects(
    this,
    this.action$,
    claimTypeActions.add,
    this.claimTypeApiService.add,
  );

  update = createApiCallEffects(
    this,
    this.action$,
    claimTypeActions.update,
    this.claimTypeApiService.update,
  );

  delete = createApiCallEffects(
    this,
    this.action$,
    claimTypeActions.delete,
    this.claimTypeApiService.delete,
  );
}
